import React from 'react';
import { POLYGON_TYPE_LOT } from '../../util/constants';
import PopupPINorPOIContent from './PopupPINorPOIContent';
import { getStatusLabel, mapStatus, getStatusColor } from '../../util/polygon';
function PopupHoverContent({ polygon }) {
    const polygonType = polygon.Properties.Type;
    const address = polygon.Properties.AddressLine2
        ? `${polygon.Properties.AddressLine1}, ${polygon.Properties.AddressLine1}`
        : polygon.Properties.AddressLine1;
    return (React.createElement("div", { className: "popup__hover-content" },
        polygonType === POLYGON_TYPE_LOT && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "popup__header" },
                React.createElement("div", { className: "popup__status", style: { backgroundColor: getStatusColor(mapStatus(polygon)) } }),
                React.createElement("h3", { className: "popup__title" }, getStatusLabel(polygon))),
            address && React.createElement("div", { className: "popup__address" }, address))),
        polygonType !== POLYGON_TYPE_LOT && (React.createElement(PopupPINorPOIContent, { description: polygon.Properties.Name }))));
}
export default React.memo(PopupHoverContent);
